import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { RecommendationModel } from '../../models/interpretation.model';
import { trigger, transition, style, animate } from '@angular/animations';
import { QuoteService } from '../../quote-service.service';
import { MatDialog } from '@angular/material/dialog';import { EditRecommendationComponent } from '../edit-recommendation/edit-recommendation.component';
import { Subscription } from 'rxjs/Subscription';
import { UserService } from '../../../../shared/services/user.service';

@Component({
  selector: 'quote-row',
  templateUrl: './quote-row.component.html',
  styleUrls: ['./quote-row.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ])
      ]
    )]
})
export class QuoteRowComponent implements OnInit {
  @Input() inspectionId: number;
  @Input() recommendationId: number;
  @Input() quoteId: number;
  @Input() quoteDetail: any;
  @Output() update: EventEmitter<any> = new EventEmitter();
  recommendation: RecommendationModel = new RecommendationModel();
  loading: boolean = true;
  isDeleting: boolean = false;
  quoteDetailSubscription: Subscription;
  isInterpreter: boolean = false;
  isInspector: boolean = false;
  LocalInspectionId: any;
 
  constructor(private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _quotes: QuoteService,
    private _dialog: MatDialog,
  private _user: UserService) { }

  ngOnInit() {
    this.checkPermissions();
    this._quotes.reloadQuoteOverview(this.inspectionId);
    this._quotes.getQuoteOverviews().subscribe(r => {
      if (this.quoteDetailSubscription != null)
        this.quoteDetailSubscription.unsubscribe();
      this.loadQuoteDetailRecord();
    });
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case "Inspectors":
              this.isInspector = true;
              break;
            case "Interpreters":
            case "Super User":
            case "Administrator":
              this.isInterpreter = true;
              this.isInspector = true;
              break;
          }
        })
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }

  loadQuoteDetailRecord() {
    this.quoteDetailSubscription = this._interp.getRecommendation(this.inspectionId, this.recommendationId).subscribe(r => {
      this.recommendation = r;
      this.loading = false;
    }, err => {
      console.error(err);
      this._notify.error('Error', 'Failed to load quote details. Please contact TrackTreads support. ');
    });
  }

  deleteRecommendation() {
    this.isDeleting = true;
    this._interp.deleteRecommendation(this.inspectionId, this.recommendationId).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Deleted', r.m_Item2);

        this.LocalInspectionId = String(this.recommendationId); // use for local storage
        localStorage.setItem('LocalIncpectionid', this.LocalInspectionId);

        this._quotes.reloadQuoteOverview(this.inspectionId);
        this.update.emit(true);
      } else {
        this._notify.error('Failed', 'Unable to delete recommendation. ');
        console.error(r.m_Item2);
        this.isDeleting = false;
      }
    }, err => {
      console.error(err);
      this._notify.error('Error', 'Failed to delete recommendation. Please contact TrackTreads support. ');
      this.isDeleting = false;
    });
  }

  openEditRecommendation() {
    let editRecommendationModalRef = this._dialog.open(EditRecommendationComponent, {
      data: {
        inspectionId: this.inspectionId,
        componentId: this.recommendation.ComponentId,
        quoteId: this.quoteId,
        recommendationId: this.recommendationId,
        recommendation: this.recommendation,
        recommendationDetail:this.quoteDetail

      }
    });
    editRecommendationModalRef.afterClosed().subscribe(recommendation => {
      if (recommendation != null)
        this._quotes.reloadQuoteOverview(this.inspectionId);
        //this.recommendation = recommendation;
    })
  }
}
